import React from 'react';
import { render } from 'react-dom';
import { AccountsPage } from './account/AccountsPage';
import { AdsDetailPage } from './ads-detail-page/AdsDetailPage';
import { ProcedureReportPage } from './ads-procedure-report-page/ProcedureReportPage';
import { AlertContainer } from './components/AlertContainer';
import { AuthStore } from './login/AuthContext';

function createAccountsApp(root:Element){
    render(
        <AuthStore>
            <AlertContainer>
                <AccountsPage />
            </AlertContainer>
        </AuthStore>
    , root);
}

function createAdsDetailApp(root:Element, account:number){
    render(
        <AuthStore>
            <AlertContainer>
                <AdsDetailPage account={account} />
            </AlertContainer>
        </AuthStore>
    , root);
}

function createProcedureReport(root:Element){
    render(
        <AuthStore>
            <AlertContainer>
                <ProcedureReportPage />
            </AlertContainer>
        </AuthStore>
    , root);
}


function createApp(){
    const root = document.querySelector('#root') as HTMLDivElement
    if(!root) return;

    if(root.dataset.account)
        return createAdsDetailApp(root, parseInt(root.dataset.account));
    
    if(root.dataset.mode == 'procedure-report')
        return createProcedureReport(root);

    return createAccountsApp(root);
}

window.addEventListener("DOMContentLoaded", createApp);
